<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19wiM5G/tc-custom/9781398400504.jpg?1685327173980" alt="This image is the cover for the book Colour Coded: The Silver Sparrow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colour Coded: The Silver Sparrow
      </h1>
      <p class="bookDescription body article font2">
        <p>Sparrow’s stress and anxiety is close to boiling point after Neon’s latest move, and it is beginning to take its toll on the rest of Colour-Coded. Somehow, they must get one step ahead of Neon. While Sparrow not only deals with troubles of the mind but of the heart as well, tempers are flaring, relationships are faltering, and Neon continuing to elude them all sets their teeth on edge. Will Sparrow’s aggravating behaviour drive them to fight harder? Or will it merely make him the weaker link and the easier target with Colour-Coded?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katy Jordan
      </h2>
      
      <p class="authorDescription body article">Katy Jordan was born and raised in Stirling, Scotland. From an early age she dreamed of becoming a writer and/or actress and for the last eight years she has been pursuing both. Official website: www.katy-jordan.co.uk [http://www.katy-jordan.co.uk/]</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?488aa8ea